(function () {
  const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
  // Remove the view transition render blocker if the user has reduced motion enabled or is on a low power device.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice()) {
    if (viewTransitionRenderBlocker) viewTransitionRenderBlocker.remove();
  } else {
    // If the browser didn't manage to parse the main content quickly, at least let the user see something.
    // We're aiming for the FCP to be under 1.8 seconds since the navigation started.
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());

    setTimeout(() => {
      if (viewTransitionRenderBlocker) viewTransitionRenderBlocker.remove();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }

  // Polyfill: requestIdleCallback is absent in Safari < 16.4 and all Firefox.
  // The fallback passes an IdleDeadline-compatible object so the callback signature is correct.
  const idleCallback =
    typeof requestIdleCallback === 'function'
      ? requestIdleCallback
      : (
          /** @type {IdleRequestCallback} */ cb,
          /** @type {IdleRequestOptions | undefined} */ opts
        ) => {
          const t = Date.now();
          const timeoutMs = (opts && opts.timeout !== undefined) ? opts.timeout : 1;
          return setTimeout(
            () => cb({ didTimeout: false, timeRemaining: () => Math.max(0, 50 - (Date.now() - t)) }),
            timeoutMs
          );
        };

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = /** @type {PageSwapEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      if (viewTransition) viewTransition.skipTransition();
      return;
    }

    if (!viewTransition) return;

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          viewTransition.skipTransition();
        },
        { once: true }
      );
    });

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered ? transitionTriggered.getAttribute('data-view-transition-type') : null;

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      sessionStorage.setItem('custom-transition-type', transitionType);
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = /** @type {PageRevealEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      if (viewTransition) viewTransition.skipTransition();
      return;
    }

    if (!viewTransition) return;

    const customTransitionType = sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        sessionStorage.removeItem('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  /**
   * @param {ViewTransition | null | undefined} viewTransition
   * @returns {boolean} True when transitions should not run (unsupported API, missing instance, or low-power device).
   */
  function shouldSkipViewTransition(viewTransition) {
    if (typeof ViewTransition === 'undefined') return true;
    return !(viewTransition instanceof ViewTransition) || isLowPowerDevice();
  }

  /*
   * We can't import this logic from utilities.js here, but we should keep them in sync.
   */
  function isLowPowerDevice() {
    /* Skip ESLint compatibility check. Number(undefined) <= 2 is always false anyway. */
    /* eslint-disable-next-line compat/compat */
    return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
  }
})();
